// Veci brand icons for HTML built in JavaScript: the same SVG files IconsHelper#veci_icon
// inlines on the server (esbuild imports them as text, see the build script).
import check from "../../assets/images/veci_icons/check.svg"
import checkCircle from "../../assets/images/veci_icons/check-circle.svg"
import warning from "../../assets/images/veci_icons/exclamation-triangle.svg"
import info from "../../assets/images/veci_icons/info.svg"
import x from "../../assets/images/veci_icons/x.svg"

const ICONS = { check, "check-circle": checkCircle, "exclamation-triangle": warning, info, x }

// icon("check", "w-5 h-5") → decorative <svg> markup coloured by currentColor
export function icon(name, classes = "w-5 h-5") {
  return ICONS[name].replace("<svg ", `<svg class="${classes}" aria-hidden="true" `)
}
